<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import ManualProcessing from './ManualProcessing/index.vue'
import ScheduledTasks from './ScheduledTasks/index.vue'
export default {
	components:{
	ScheduledTasks,
	ManualProcessing
	},
	data() {
		return {
			searchlist:getdata().searchlist,
			searchdata:getdata().searchdata,
			activeName:'ScheduledTasks',
			overlength:0,
			list:'',
		}; 
	}, 
	mounted() {
	
	},
	created() {},
	methods: {//
	//所搜
		submitSearch(){
			this.list = this.searchdata
		},
		geOoverLength(e){
		  this.overlength = e;
	  },
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
